import { render } from "./SavedIdeasNav.vue?vue&type=template&id=7b16edee"
import script from "./SavedIdeasNav.vue?vue&type=script&lang=js"
export * from "./SavedIdeasNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__